import { useQuery } from "react-query";
import { getLeasedEquipmentModelList } from "../../../../../actions/Utilities/LeasedEquipmentModel";

export default function useGetModelList() {
  return useQuery("GetModel", getLeasedEquipmentModelList, {
    refetchOnWindowFocus: false,
  });
}
